import { SynthesizeSpeechCommand } from "@aws-sdk/client-polly";
import { getSignedUrl } from "./getSignedUrls";
export const getSynthesizeSpeechUrl = async (input) => {
    const command = new SynthesizeSpeechCommand(input.params);
    const options = input.options || {};
    return await getSignedUrl(input.client, command, options);
};
